export default "\n<h2>Retailers</h2>\n<hr>\n<app-table></app-table>\n\n";